"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMembersList = void 0;
const axios_1 = __importDefault(require("axios"));
/**
 * Returns a list of all members.
 *
 * ### Filter options
 *
 * - `isMember` - filters by user's curator membership status,
 * - `isPrivate` - filters by user's Steam privacy settings,
 *
 * ### Sort options
 *
 * - `lastUpdated` - sorts by the time passed since last member's profile update.
 *
 * ## Usage
 *
 * ```ts
 * const membersAll: Member[] = await sdk.getMembersList({ });
 * const membersInactive: Member[] = await sdk.getMembersList({ sort: { lastUpdated: 'desc' }});
 * const membersCurator: Member[] = await sdk.getMembersList({ filter: { isMember: true }});
 * ```
 *
 * @param params.filter - Filter to apply to returned member list.
 * @param params.sort - Fields to sort member list by.
 * @param params.limit - How many members will get returned.
 */
const getMembersList = (params, 
/** @ignore */
BASE_URL) => __awaiter(void 0, void 0, void 0, function* () {
    const { filter, sort, limit } = params;
    const url = `${BASE_URL}/members/list`;
    const memberResponse = yield axios_1.default.post(url, { filter, sort, limit }, { validateStatus: () => true });
    const { status, data } = memberResponse;
    if (status !== 200)
        throw new Error(data.error);
    return data;
});
exports.getMembersList = getMembersList;
